import { AccordionBlock } from '@/blocks/AccordionBlock'
import { AccordionItemBlock } from '@/blocks/AccordionItemBlock'
import { AddonBlock } from '@/blocks/AddonBlock/AddonBlock'
import { AppShowcaseBlock } from '@/blocks/AppShowcaseBlock'
import { AverageRatingBannerBlock } from '@/blocks/AverageRatingBannerBlock'
import { ButtonBlock } from '@/blocks/ButtonBlock'
import { CardLinkBlock } from '@/blocks/CardLinkBlock'
import { CardLinkListBlock } from '@/blocks/CardLinkListBlock'
import { CardLinkSmallBlock } from '@/blocks/CardLinkSmallBlock/CardLinkSmallBlock'
import { ComparisonTableBlock } from '@/blocks/ComparisonTableBlock'
import { ConfirmationPageBlock } from '@/blocks/ConfirmationPageBlock'
import { ConnectPaymentBlock } from '@/blocks/ConnectPaymentBlock'
import { ContentGridBlock } from '@/blocks/ContentGridBlock/ContentGridBlock'
import { ContentGridItemBlock } from '@/blocks/ContentGridItemBlock/ContentGridItemBlock'
import { CookieListBlock } from '@/blocks/CookieListBlock/CookieListBlock'
import { CookiePreferenceButtonBlock } from '@/blocks/CookiePreferenceButtonBlock/CookiePreferenceButtonBlock'
import { CookiesPageBlock } from '@/blocks/CookiesPageBlock/CookiesPageBlock'
import { CoverageListBlock } from '@/blocks/CoverageListBlock/CoverageListBlock'
import { CustomSchemaOrg } from '@/blocks/CustomSchemaOrg'
import { DownloadableContentItemBlock } from '@/blocks/DownloadableContentItemBlock'
import { FloatBannerBlock } from '@/blocks/FloatBannerBlock/FloatBannerBlock'
import { GridBlock } from '@/blocks/GridBlock'
import { HeadingBlock } from '@/blocks/HeadingBlock/HeadingBlock'
import { HeadingLabelBlock } from '@/blocks/HeadingLabelBlock'
import { HeroBlock } from '@/blocks/HeroBlock/HeroBlock'
import { IframeBlock } from '@/blocks/IframeBlock'
import { ImageBlock } from '@/blocks/ImageBlock/ImageBlock'
import { ImageTextBlock } from '@/blocks/ImageTextBlock'
import { InlineSpaceBlock } from '@/blocks/InlineSpaceBlock'
import { InsurableLimitsBlock } from '@/blocks/InsurableLimitsBlock'
import { InsuranceGuideBlockDynamic } from '@/blocks/InsuranceGuideBlock/InsuranceGuideBlockDynamic'
import { MediaListBlock } from '@/blocks/MediaListBlock'
import { ModalBlock } from '@/blocks/ModalBlock'
import { PageBlock } from '@/blocks/PageBlock'
import { PerilsBlock } from '@/blocks/PerilsBlock'
import { PerilsTableBlock } from '@/blocks/PerilsTableBlock'
import { ProductAverageRatingBlock } from '@/blocks/ProductAverageRatingBlock'
import { ProductButtonItemBlock } from '@/blocks/ProductButtonsBlock/ProductButtonItemBlock'
import { ProductButtonsBlock } from '@/blocks/ProductButtonsBlock/ProductButtonsBlock'
import { ProductDocumentsBlock } from '@/blocks/ProductDocumentsBlock'
import { ProductGridBlock } from '@/blocks/ProductGridBlock'
import { ProductGridItemBlock } from '@/blocks/ProductGridItemBlock/ProductGridItemBlock'
import { ProductPageBlock } from '@/blocks/ProductPageBlock/ProductPageBlock'
import { ProductPillowBlock } from '@/blocks/ProductPillowsBlock/ProductPillowBlock'
import { ProductPillowsBlock } from '@/blocks/ProductPillowsBlock/ProductPillowsBlock'
import { ProductPurchaseBlock } from '@/blocks/ProductPurchaseBlock'
import { ProductReviewsBlock } from '@/blocks/ProductReviewsBlock'
import { ProductTierComparisonBlock } from '@/blocks/ProductTierComparisonBlock'
import { QuickPurchaseBlock } from '@/blocks/QuickPurchaseBlock'
import { ReusableBlockReference } from '@/blocks/ReusableBlockReference'
import { ReviewsSlideshowBlock } from '@/blocks/ReviewsSlideshowBlock/ReviewsSlideshowBlock'
import { RichTextBlock } from '@/blocks/RichTextBlock/RichTextBlock'
import { SelectInsuranceGridBlock } from '@/blocks/SelectInsuranceGridBlock/SelectInsuranceGridBlock'
import { SlideshowBlock } from '@/blocks/SlideshowBlock/SlideshowBlock'
import { SpacerBlock } from '@/blocks/SpacerBlock/SpacerBlock'
import { StackBlock } from '@/blocks/StackBlock/StackBlock'
import { StoryCarouselBlock } from '@/blocks/StoryCarouselBlock/StoryCarouselBlock'
import { TabsBlock } from '@/blocks/TabsBlock'
import { TextBlock } from '@/blocks/TextBlock/TextBlock'
import { TextContentBlock } from '@/blocks/TextContentBlock'
import { TickerBlock } from '@/blocks/TickerBlock'
import { USPBlock, USPBlockItem } from '@/blocks/USPBlock'
import { VideoBlock } from '@/blocks/VideoBlock'
import { WidgetFlowBlock } from '@/blocks/WidgetFlowBlock'
import { YoutubeVideoBlock } from '@/blocks/YoutubeVideoBlock/YoutubeVideoBlock'
const blockAliases = { reusableBlock: PageBlock }

export const commonStoryblokComponents = {
  appShowcase: AppShowcaseBlock,
  accordion: AccordionBlock,
  accordionItem: AccordionItemBlock,
  addonBlock: AddonBlock,
  averageRatingBanner: AverageRatingBannerBlock,
  button: ButtonBlock,
  cardLink: CardLinkBlock,
  cardLinkList: CardLinkListBlock,
  cardLinkSmall: CardLinkSmallBlock,
  comparisonTable: ComparisonTableBlock,
  confirmation: ConfirmationPageBlock,
  contentGrid: ContentGridBlock,
  contentGridItem: ContentGridItemBlock,
  connectPayment: ConnectPaymentBlock,
  cookieList: CookieListBlock,
  cookiePreferenceButton: CookiePreferenceButtonBlock,
  cookiesPage: CookiesPageBlock,
  coverageListBlock: CoverageListBlock,
  downloadableContentItem: DownloadableContentItemBlock,
  floatBanner: FloatBannerBlock,
  grid: GridBlock,
  heading: HeadingBlock,
  headingLabel: HeadingLabelBlock,
  hero: HeroBlock,
  iframe: IframeBlock,
  image: ImageBlock,
  imageText: ImageTextBlock,
  inlineSpace: InlineSpaceBlock,
  insurableLimits: InsurableLimitsBlock,
  insuranceGuide: InsuranceGuideBlockDynamic,
  mediaList: MediaListBlock,
  modal: ModalBlock,
  page: PageBlock,
  perils: PerilsBlock,
  perilsTable: PerilsTableBlock,
  product: ProductPageBlock,
  productAverageRating: ProductAverageRatingBlock,
  productGridItemBlock: ProductGridItemBlock,
  productDocuments: ProductDocumentsBlock,
  productGrid: ProductGridBlock,
  productButtonItem: ProductButtonItemBlock,
  productButtons: ProductButtonsBlock,
  productPillow: ProductPillowBlock,
  productPillows: ProductPillowsBlock,
  productPurchase: ProductPurchaseBlock,
  productReviews: ProductReviewsBlock,
  reviewsSlideshow: ReviewsSlideshowBlock,
  productTierComparison: ProductTierComparisonBlock,
  quickPurchase: QuickPurchaseBlock,
  reusableBlockReference: ReusableBlockReference,
  richText: RichTextBlock,
  selectInsuranceGrid: SelectInsuranceGridBlock,
  slideshow: SlideshowBlock,
  spacer: SpacerBlock,
  stack: StackBlock,
  tabs: TabsBlock,
  text: TextBlock,
  textContent: TextContentBlock,
  ticker: TickerBlock,
  usp: USPBlock,
  uspItem: USPBlockItem,
  videoBlock: VideoBlock,
  youtubeVideo: YoutubeVideoBlock,
  widgetFlow: WidgetFlowBlock,
  storyCarousel: StoryCarouselBlock,
  customSchemaOrg: CustomSchemaOrg,
  ...blockAliases,
}
